/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';

class InfoCard extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let className = 'card card-info';
        if (this.props.className)
            className = `${className} ${this.props.className}`;

        return (
            <div className={className}>
                <div className="card-content">
                    <p className="card-title">{this.props.title}</p>
                    <p className="card-value">{this.props.children}</p>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps, {})(InfoCard);
